import { PlatformService } from '../../platform/platform.service';
import { LogEnvVarUserOfflineAndroidDao } from './log-envvaruser-offline-android.dao';
import { LogEnvVarUserOfflineWebDao } from './log-envvaruser-offline-web.dao';
import { LogEnvVarUserOfflineDao } from './log-envvaruser-offline.dao';

const LogEnvVarUserOfflineDaoFactory = (platformService: PlatformService) => platformService.isAndroidApp() ? 
    new LogEnvVarUserOfflineAndroidDao() : new LogEnvVarUserOfflineWebDao();

export const LogEnvVarUserOfflineDaoProvider = { 
    provide: LogEnvVarUserOfflineDao,
    useFactory: LogEnvVarUserOfflineDaoFactory,
    deps: [PlatformService]
};